document.addEventListener('DOMContentLoaded', () => {
  const isHeaderPositionFixed = window.innerWidth > 1023
  if (!isHeaderPositionFixed) return

  const headerElement = document.querySelector('header.header')
  if (!headerElement) return

  const headerHeight = headerElement.clientHeight
  const mainElement = document.querySelector('.main')
  mainElement.style.marginTop = `${headerHeight}px`
})
